function loadCookies(langCode = 'en'){
  if (window.cookieConsentLoaded) {
    return;
  }  
  
  window.cookieConsentLoaded = true;

  var otAutoBlockScript = document.createElement("script");
  otAutoBlockScript.type = "text/javascript";
  otAutoBlockScript.src = "https://cdn.cookielaw.org/consent/85a75c0e-ed47-4622-b0fa-aed06e385dc5/OtAutoBlock.js";
  document.head.appendChild(otAutoBlockScript);

  var otSDKStubScript = document.createElement("script");
  otSDKStubScript.type = "text/javascript";
  otSDKStubScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  otSDKStubScript.charset = "UTF-8";
  otSDKStubScript.setAttribute("data-domain-script", "85a75c0e-ed47-4622-b0fa-aed06e385dc5");
  
  otSDKStubScript.setAttribute("data-language", langCode);
  otSDKStubScript.setAttribute("data-document-language", "true"); 

  document.head.appendChild(otSDKStubScript);

  window.OptanonWrapper = function() {
  };
}


function hasUserApprovedCookies() {
  const cookie = document.cookie
    .split("; ")
    .find(c => c.startsWith("OptanonActiveGroups="));

  if (!cookie) return false;

  const cookieValue = decodeURIComponent(cookie.split("=")[1]);
  return cookieValue.includes("C0002") || 
         cookieValue.includes("C0003") || 
         cookieValue.includes("C0004"); 
}
  function getCookiesLng(direction){
    return direction.toString().toLowerCase() ==='rtl' ? 'he-IL' : 'en'
}

export {loadCookies,hasUserApprovedCookies,getCookiesLng};